import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const SalesForm = ({ salesForm }: SpecProps<"sales_form">) => {
  const { i18n } = useLingui();

  if (!salesForm) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.sales_form",
    message: "Sales form",
    comment: "Field for 'sales form' in ad specification",
  });
  return <FieldValuePair field={field} value={salesForm} />;
};
